import React from "react";

const Delete = () => {
  return (
    <div className="text-sm mb-2">
      <p>Mouse behavior when deleting graphics:</p>
      <ul className="list-disc px-4 mt-2">
        <li>
          To delete a graphic, right-click the graphic and select 'Delete
          Graphic' from the menu.
        </li>
      </ul>
    </div>
  );
};

export default Delete;
